import { extendTheme, ThemeConfig } from '@chakra-ui/react';
const config: ThemeConfig = {
  initialColorMode: 'light',
  useSystemColorMode: true,
};

const janusTheme = extendTheme({
  config,
  styles: {
    global: {
      '.ab-widget': {
        'color-scheme': 'normal !important',
        backgroundColor: 'rgba(196, 181, 253, 0.3) !important',
        backdropFilter: 'blur(10px) saturate(180%)',
        WebkitBackdropFilter: 'blur(10px) saturate(180%)',
      },
    },
  },
  fonts: {
    heading: 'Inter',
    body: 'Inter',
  },

  components: {
    Button: {
      defaultProps: {
        colorScheme: 'purple',
        type: 'submit',
      },
    },

    Heading: {
      baseStyle: {
        fontSize: '3xl',
        fontWeight: 'bold',
        color: 'purple.500',
      },
    },
  },
});

export default janusTheme;
